export function joinKeywords(...keywords) {
  const result = [];
  for (let kws of keywords) {
    for (let keyword of [].concat(kws || [])) {
      keyword = ('' + (keyword || '')).trim();
      if (keyword) {
        result.push(keyword);
      }
    }
  }
  return result.join(', ');
}
